import {createContext} from "react";
import ImageStore from "./impl/ImageStore";

class RootStore {
  ImageStore = new ImageStore();
}

const StoreList = new RootStore();
const StoreContext = createContext(StoreList);

export {StoreList, StoreContext};